import React from "react";
import { Box } from "@bca/ui-library";

const GradeUnknownSVG: React.FunctionComponent = () => (
  <Box display="flex">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#E5E8E9"/>
      <path d="M8 7.188c0-.366.292-.688.667-.688h6.666c.354 0 .667.322.667.688a.682.682 0 0 1-.667.687v.236c0 .924-.354 1.805-.979 2.45L12.938 12l1.416 1.46c.625.645.98 1.526.98 2.429v.236c.354 0 .666.322.666.688a.682.682 0 0 1-.667.687H8.667A.669.669 0 0 1 8 16.812c0-.365.292-.687.667-.687v-.236c0-.903.333-1.784.958-2.428L11.042 12l-1.417-1.44C9 9.916 8.667 9.035 8.667 8.111v-.236A.669.669 0 0 1 8 7.187Zm2 .687v.236c0 .559.208 1.075.583 1.461L12 11.033l1.396-1.46C13.77 9.185 14 8.67 14 8.11v-.236h-4Zm0 8.25h4v-.236c0-.537-.23-1.053-.604-1.44L12 12.99l-1.417 1.46A2.08 2.08 0 0 0 10 15.91v.236-.021Z" fill="#1D2948"/>
    </svg>
  </Box>
);

export default GradeUnknownSVG;
